<template>
<div class="nnlzt">
    <div class="wd-loading" v-if="loading">
      正在加载，请稍后......
    </div>
    <div v-else>
    <div v-if="noItem">
        暂无训练记录，可点击右上角“现场训练”按钮进行训练
    </div>
    <div class="status-container" v-else>
        <div class="status-echarts-container" v-if="showOneDetail">
            <echart v-if="showStatusChart" :index='statusIndex' :option='statusOption' :width="'600px'" :height="'400px'"></echart>
            <echart v-if="showLineChart" :index='lineIndex' :option='lineOption' :width="'600px'" :height="'400px'"></echart>
            <div style="font-size:12px;color:#999;margin-top:20px;">*“情绪与社会认知”暂不统计脑力值<br>
                <span style="margin-left:17px;">训练完成越多，脑力值越准确</span></div>
            <div class="status-echarts-menu">
                <label for="select-all" class="select-label">
                    <input id="select-all" class="select-radio" type="radio" name="ability" value="a" v-model="ability">
                    <span>全部</span>
                </label>
                <label for="select-mem" class="select-label">
                    <input id="select-mem" class="select-radio" type="radio" name="ability" value="53" v-model="ability">
                    <span>记忆力</span>
                </label>
                <label for="select-attention" class="select-label">
                    <input id="select-attention" class="select-radio" type="radio" name="ability" value="54" v-model="ability">
                    <span>注意力</span>
                </label>
                <label for="select-perception" class="select-label">
                    <input id="select-perception" class="select-radio" type="radio" name="ability" value="55" v-model="ability">
                    <span>感知觉</span>
                </label>
                <label for="select-agility" class="select-label">
                    <input id="select-agility" class="select-radio" type="radio" name="ability" value="56" v-model="ability">
                    <span>敏捷性</span>
                </label>
                <label for="select-execution" class="select-label">
                    <input id="select-execution" class="select-radio" type="radio" name="ability" value="57" v-model="ability">
                    <span>执行功能</span>
                </label>
                <label for="select-thought" class="select-label">
                    <input id="select-thought" class="select-radio" type="radio" name="ability" value="58" v-model="ability">
                    <span>思维</span>
                </label>
                <label for="select-speak" class="select-label">
                    <input id="select-speak" class="select-radio" type="radio" name="ability" value="11" v-model="ability">
                    <span>言语-语言</span>
                </label>
                <label for="select-perceive" class="select-label">
                    <input id="select-perceive" class="select-radio" type="radio" name="ability" value="12" v-model="ability">
                    <span>情绪与社会认知</span>
                </label>
            </div>
            <div class="status-echarts-table">
                <div class="status-echarts-table-one">
                    <div v-if="haveThisOne" style="margin-top:20px;">
                        <echart v-if="showOneChart" :index='oneIndex' :option='oneOption' :width="'300px'" :height="'200px'"></echart>
                    </div>
                    <div v-else style="color:#999;width:300px;height:200px;margin-top:100px;">
                        暂无此脑能力的训练
                    </div>
                </div>
                <table class="status-echarts-table-two" v-if="haveThisOne" style="margin-top:20px;">
                    <!-- <caption>训练数据</caption> -->
                    <thead style="background-color:#f8f8f8;">
                        <tr>
                        <th>名称</th>
                        <th>累计训练</th>
                        <th>最新得分</th>
                        <th>最高得分</th>
                        <th>首次训练</th>
                        <th>最近训练</th>
                        </tr>
                    </thead>
                    <tbody class="tbody-max-height">
                        <tr v-for="(item,index) in tableList" @click="showOneGameData(uid,item.id,item.lesson_type,item.name,index)">
                            <td v-if="index==choseIndex" class="tdactive" :title="item.name">{{item.name | cutors}}</td> <td v-else :title="item.name">{{item.name | cutors}}</td>
                            <td v-if="index==choseIndex" class="tdactive">{{item.cumulative_days}}天,{{item.train_num}}局</td> <td v-else>{{item.cumulative_days}}天,{{item.train_num}}局</td>
                            <td v-if="index==choseIndex" class="tdactive">{{item.score}}</td> <td v-else>{{item.score}}</td>
                            <td v-if="index==choseIndex" class="tdactive">{{item.max_score}}</td> <td v-else>{{item.max_score}}</td>
                            <td v-if="index==choseIndex" class="tdactive">{{item.first_train_date}}</td> <td v-else>{{item.first_train_date}}</td>
                            <td v-if="index==choseIndex" class="tdactive">{{item.recent_train_date}}</td> <td v-else>{{item.recent_train_date}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    </div>
    </div>
</template>

<script>
import echart from './echart.vue';
export default {
    data: function () {
        return {
            userData:null,
            uid:this.$route.params.id,
            showStatusChart:false,
            statusIndex:'540',
            statusOption:null,
            showLineChart:false,
            lineIndex:'541',
            lineOption:null,
            showOneChart:false,
            oneIndex:'542',
            oneOption:null,
            ability:'a',//初始选中能力选项
            tableList:null,//表格游戏列表
            dataOne:[],
            indicatorOne:[],
            xAxisTwo:[],
            seriesTwo:[],
            noItem:false,
            showOneDetail:false,//初始化单项列表隐藏
            haveThisOne:true,//没有单项脑能力的情况下
            choseIndex:0,
            loading:true,
        }
    },
    filters:{
        cutors(val){
            let val2 = val || "";
            let len = val2.length;
            if(len > 6){
                return val2.slice(0,5)+"...";
            }
            return val2;
        }
    },
    watch: {
        ability(newV,oldV){
            console.log(newV);
            this.fromAbilityToGame(newV);
        }
    },
    components: {
        echart
    },
    created(){
        this.statusInit();
    },
    mounted(){
        this.echartInit();
        console.log(this.uid)
    },
    methods:{
        statusInit(){
            let self = this;
            this.$http.get('/api/Users/me').then((res)=>{
                self.userData=res.data;
                console.log('////////////////////');
                console.log(self.userData);
            }).then(()=>{
                self.fromAbilityToGame();//初始化获取所有脑能力
                self.doStatusEchart();
            });
        },
        doStatusEchart(){
            let self = this;
            // let uid = self.userData.account_uuid;
            let uid = self.uid;
            this.$http.get('api/Train/brainCapRadrMap', {params:{
                    'uid':uid
                }}).then((res)=>{
                let datas1= res.data.data;
                let refer=['11','12','53','54','55','56','57','58'];//作为参照的脑能力数组
                let truerefer = [];//存储真实存在的脑能力
                let dataTwo = [];//存储第二个图上面的tag标签
                for(let [key,value] of Object.entries(datas1)){
                    let max = 100;//雷达图最大值
                    let score = value.score.filter(res=>res!=null);
                        score = Math.round(score[score.length-1]);//取雷达图最后一个值
                    let xAxisTwo = value.date;//折线图脑能力横坐标日期
                    self.xAxisTwo = xAxisTwo;//折线图脑能力横坐标日期
                    switch(key){
                        case '53':
                            truerefer.push('53');
                            self.indicatorOne.push({name:'记忆力',max:max});
                            self.dataOne.push(score);
                            self.seriesTwo.push({
                                name:'记忆力',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'#C6D835',
                                        lineStyle:{
                                            color:'#C6D835'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('记忆力');
                            break;
                        case '54':
                            truerefer.push('54');
                            self.indicatorOne.push({name:'注意力',max:max});
                            self.dataOne.push(score);
                            self.seriesTwo.push({
                                name:'注意力',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'#1BBE9F',
                                        lineStyle:{
                                            color:'#1BBE9F'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('注意力');
                            break;
                        case '55':
                            truerefer.push('55');
                            self.indicatorOne.push({name:'感知觉',max:max});
                            self.dataOne.push(score);
                            self.seriesTwo.push({
                                name:'感知觉',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'#F5A623',
                                        lineStyle:{
                                            color:'#F5A623'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('感知觉');
                            break;
                        case '56':
                            truerefer.push('56');
                            self.indicatorOne.push({name:'敏捷性',max:max});
                            self.dataOne.push(score);
                            self.seriesTwo.push({
                                name:'敏捷性',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'#E75710',
                                        lineStyle:{
                                            color:'#E75710'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('敏捷性');
                            break;
                        case '57':
                            truerefer.push('57');
                            self.indicatorOne.push({name:'执行功能',max:max});
                            self.dataOne.push(score);
                            self.seriesTwo.push({
                                name:'执行功能',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'#4A90E2',
                                        lineStyle:{
                                            color:'#4A90E2'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('执行功能');
                            break;
                        case '58':
                            truerefer.push('58');
                            self.indicatorOne.push({name:'思维',max:max});
                            self.dataOne.push(score);
                            self.seriesTwo.push({
                                name:'思维',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'#667EE5',
                                        lineStyle:{
                                            color:'#667EE5'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('思维');
                            break;
                        case '11':
                            truerefer.push('11');
                            self.indicatorOne.push({name:'言语-语言',max:max});
                            self.dataOne.push(parseInt(score));
                            self.seriesTwo.push({
                                name:'言语-语言',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'#AC81E4',
                                        lineStyle:{
                                            color:'#AC81E4'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('言语-语言');
                            break;
                        case '12':
                            truerefer.push('12');
                            self.indicatorOne.push({name:'情绪与社会认知',max:max});
                            self.dataOne.push(score);
                            self.seriesTwo.push({
                                name:'情绪与社会认知',
                                type:'line',
                                itemStyle : {
                                    normal : {
                                        color:'red',
                                        lineStyle:{
                                            color:'yellow'
                                        }
                                    }
                                },
                                smooth: true,
                                connectNulls:true,
                                data:value.score.map(res=>res!=null? Math.round(res):null)
                            });
                            dataTwo.push('情绪与社会认知');
                            break;
                        default:
                            break;
                    }
                }
                console.log('------..........')
                if(truerefer.length!=7){//判断是否需要补全脑能力
                    let buquan = (refer.filter(res=> (truerefer.indexOf(res)<0)));
                    let max = 100;
                    for(let [key,value] of Object.entries(buquan)){
                        switch(value){
                            case '53':
                                truerefer.push('53');
                                self.indicatorOne.push({name:'记忆力',max:max});
                                self.dataOne.push(0);
                                break;
                            case '54':
                                truerefer.push('54');
                                self.indicatorOne.push({name:'注意力',max:max});
                                self.dataOne.push(0);
                                break;
                            case '55':
                                truerefer.push('55');
                                self.indicatorOne.push({name:'感知觉',max:max});
                                self.dataOne.push(0);
                                break;
                            case '56':
                                truerefer.push('56');
                                self.indicatorOne.push({name:'敏捷性',max:max});
                                self.dataOne.push(0);
                                break;
                            case '57':
                                truerefer.push('57');
                                self.indicatorOne.push({name:'执行功能',max:max});
                                self.dataOne.push(0);
                                break;
                            case '58':
                                truerefer.push('58');
                                self.indicatorOne.push({name:'思维',max:max});
                                self.dataOne.push(0);
                                break;
                            case '11':
                                truerefer.push('11');
                                self.indicatorOne.push({name:'言语-语言',max:max});
                                self.dataOne.push(0);
                                break;
                            // case '12':
                            //     truerefer.push('12');
                            //     self.indicatorOne.push({name:'情绪与社会认知',max:max});
                            //     self.dataOne.push(0);
                            //     break;
                            default:
                                break;
                        }
                    }
                }
                self.echartOne(self.indicatorOne,self.dataOne);
                self.echartTwo(self.xAxisTwo,self.seriesTwo,dataTwo);
            });
        },
        echartOne(indicatorOne,dataOne){
            // 指定图表的配置项和数据(脑能力值)
                let statusOption = {
                    title: {
                        text: '脑力雷达图'
                    },
                    tooltip: {
                        position:['60%','50%']
                    },
                    legend: {
                        data: ['正常值分配', '实际值分配']
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                title:'保存图片'
                            }
                        },
                        right:'5%'
                    },
                    radar: {
                        // shape: 'circle',
                        name: {
                            textStyle: {
                                color: '#fff',
                                backgroundColor: '#999',
                                borderRadius: 3,
                                padding: [3, 5]
                        }
                        },
                        nameGap:10,
                        // indicator: [
                        // { name: '注意力', max: 100},
                        // { name: '语言-言语', max: 100},
                        // { name: '思维', max: 100},
                        // { name: '执行功能', max: 100},
                        // { name: '记忆力', max: 100},
                        // { name: '感知觉', max: 100},
                        // { name: '敏捷性', max: 100},
                        // ]
                        indicator:indicatorOne
                    },
                    series: [{
                        name: '脑力雷达图',
                        type: 'radar',
                        itemStyle: {
                            normal: {
                                color: '#1BBE9F'
                            }
                        },
                        // areaStyle: {normal: {}},
                        data : [
                            // {
                            //     value : [60, 60, 60, 60, 60, 60,60],
                            //     name : '正常值分配'
                            // },
                            {
                                // value : [20, 30, 40, 50, 60, 70,80],
                                value : dataOne,
                                // name : '实际值分配'
                            }
                        ]
                    }]
                };
                this.statusOption = statusOption;
                this.showStatusChart=true;
        },
        echartTwo(xAxisTwo,seriesTwo,dataTwo){
            let self = this;
            // 指定图表的配置项和数据(脑能力值)
                let lineOption= {
                    title: {
                        text: '脑力折线图',
                        left:'0',
                        top:'0'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        // data:['注意力','语言-言语','思维','执行功能','记忆力','感知觉','敏捷性']
                        data:dataTwo,
                        top:'6%'
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        // top:'auto',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                title:'保存图片'
                            }
                        },
                        right:'5%'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        // data: ['周一','周二','周三','周四','周五','周六','周日']
                        data: xAxisTwo,
                        axisLabel: {
                            showMaxLabel: true
                            // interval:0,//横轴全部显示
                            // rotate:45,//45度角度倾斜显示
                        },
                    },
                    yAxis: {
                        type: 'value'
                    },
                    // series: [
                    //     {
                    //         name:'注意力',
                    //         type:'line',
                    //         smooth: true,
                    //         connectNulls:true,
                    //         data:[10, "-", 30, 40, "-", 60, 70]
                    //     },
                    //     {
                    //         name:'语言-言语',
                    //         type:'line',
                    //         smooth: true,
                    //         data:[20, 82, 91, 34, 90, 30, 10]
                    //     },
                    //     {
                    //         name:'思维',
                    //         type:'line',
                    //         smooth: true,
                    //         data:[50, 32, 1, 54, 90, 30, 10]
                    //     },
                    //     {
                    //         name:'执行功能',
                    //         type:'line',
                    //         smooth: true,
                    //         data:[20, 32, 1, 34, 90, 30, 20]
                    //     },
                    //     {
                    //         name:'记忆力',
                    //         type:'line',
                    //         smooth: true,
                    //         data:[20, 32, 1, 34, 90, 30, 20]
                    //     },
                    //     {
                    //         name:'感知觉',
                    //         type:'line',
                    //         smooth: true,
                    //         data:[20, 32, 1, 34, 90, 30, 20]
                    //     },
                    //     {
                    //         name:'敏捷性',
                    //         type:'line',
                    //         smooth: true,
                    //         data:[20, 32, 1, 34, 90, 30, 20]
                    //     }
                    // ]
                    series:seriesTwo
                };
                this.lineOption = lineOption;
                this.showLineChart=true;
        },
        echartInit(){
            
                
                //每个游戏的细节得分
                // let oneOption = {
                //     title: {
                //         text: '单个游戏曲线'
                //     },
                //     toolbox: {
                //         feature: {
                //             saveAsImage: {}
                //         }
                //     },
                //     xAxis: {},
                //     yAxis: {},
                //     series: [{
                //         symbolSize: 20,
                //         data: [
                //             [10.0, 8.04],
                //             [8.0, 6.95],
                //             [13.0, 7.58]
                //         ],
                //         type: 'scatter'
                //     }]
                // };
                // this.oneOption = oneOption;
                // this.showOneChart = true;
        },
        fromAbilityToGame(ability='a'){
            let self = this;
            self.$http.get('api/Train/userTrainRecord', {params:{
                    // 'uid':self.userData.account_uuid,
                    'uid':self.uid,
                    'ability':ability,
                }}).then((res)=>{
                    console.log("+++---++++++++");
                    console.log(res.data.data);
                    if(res.data.data.length!=0){
                        self.noItem = false;
                        self.showOneDetail = true;
                        self.haveThisOne=true;
                        self.loading = false;
                        self.tableList = res.data.data;
                        self.showOneGameData(self.uid,self.tableList[0].id,self.tableList[0].lesson_type,self.tableList[0].name,0);//默认显示第一条游戏数据
                    }else{
                        self.loading = false;
                        if(ability=='a'){
                            self.noItem = true;
                            self.showOneDetail = false;
                        }else{//没有数据但也不是全部的情况下
                            self.haveThisOne=false;
                            self.tableList = null;
                        }
                    }
                    // self.tableList = res.data.data;
                    // self.showOneGameData(self.uid,self.tableList[0].id,self.tableList[0].lesson_type);//默认显示第一条游戏数据
            }).catch((err)=>{
                self.loading = false;
                if(ability=='a'){
                    self.noItem = true;
                    self.showOneDetail = false;
                }else{//没有数据但也不是全部的情况下
                    self.haveThisOne=false;
                    self.tableList = null;
                }
            })
        },
        showOneGameData(uid,game_id,lesson_type,game_name,choseIndex){
            let self = this;
            self.choseIndex = choseIndex;
            self.showOneChart = false;
            self.$http.get('api/Train/userTrainScoreCurve', {params:{
                    'uid':uid,
                    'game_id':game_id,
                    'lesson_type':lesson_type
                }}).then((res)=>{
                    console.log("-----");//showOneDetail
                    console.log(res.data.data);
                    let xDatas=[],yDatas=[],xyDatas=res.data.data;
                    for(let xy in xyDatas){
                        xDatas.push(xyDatas[xy].day);
                        yDatas.push(xyDatas[xy].score);
                    }
                    self.oneOption={
                        title: {
                            text: game_name,
                            x: 'center'
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        grid: {
                        left: '15%',
                        right: '15%',
                        },
                        xAxis: {
                            name: '日期',
                            nameLocation:'end',
                            nameGap:0,
                            nameTextStyle: {
                            color: '#444'
                            },
                            axisLine: {
                            lineStyle: {
                                color: '#eee'
                            }
                            },
                            axisLabel: {
                            textStyle: {
                                color: '#444'
                            },
                            showMaxLabel: true
                            // interval:0,//横轴全部显示
                            // rotate:45,//45度角度倾斜显示
                            },
                            boundaryGap : false,  // 从y轴开始显示
                            data: xDatas
                        },
                        yAxis: {
                            name: '最高得分',
                            nameTextStyle: {
                            color: '#444'
                            },
                            axisLine: {
                            lineStyle: {
                                color: '#eee'
                            }
                            },
                            axisLabel: {
                            textStyle: {
                                color: '#444'
                            }
                            },
                            splitLine: {
                            lineStyle: false
                            }
                        },
                        series: [{
                            name: ['分数'],
                            type: 'line',
                            itemStyle: {
                            normal: {
                                areaStyle: {
                                type: 'default',
                                color:'#CDE5FA'     // 填充区域颜色
                                },
                                lineStyle: {
                                color: '#0a81e5'    // 曲线颜色
                                },
                                color: '#0a81e5'      // 标注颜色
                            }
                            },
                            smooth: true,   // 折线平滑展示
                            data: yDatas
                        }]
                        };
                        self.showOneChart = true;
            })
        }
    }
}
</script>

<style scoped>
.nnlzt{
    
}
.status-container{
    /* margin-top:80px; */
    display:flex;
    justify-content:center;
}
.status-echarts-container{
    display:flex;
    flex-direction:column;
}
.status-echarts-table{
    /* border:1px solid #ccc; */
    margin:0 0 30px 0;
    display: flex;
    flex-direction:row;
}
.status-echarts-menu{
    margin-top:30px;
    /* border:1px solid #ccc; */
}
.status-echarts-table-one{
    width:40%;
    min-height:400px;
}
.status-echarts-table-two{
    display:block;
    height:170px!important;
    overflow-y: scroll !important;
}
table tbody td {
    padding-left: 0;
}
table tbody tr {
    height: auto;
    border-bottom: 0px solid #dedede;
}
table{
    width:60%;
    margin:0;
    border-left: 0px solid #dedede;
}
table th{
    font-weight:bold;
}
table th,table td{
    width:15%;
    text-align:left;
}
table tr:hover{
    cursor:pointer;
    background-color:#f8f8f8;
}
/* table tr:nth-child(odd){
    background:#eee;
} */
table td.tdactive{
    background:#eee;
}
.select-label{
    display:inline-block;
    /* margin-right:10px; */
}
.select-label span{
    color:#000;
    display:inline-block;
    cursor:pointer;
    min-width:80px;
    text-align:center;
    border-radius:2px;
    height:30px;
    line-height:30px;
    padding:0 5px;
    background-color:#eee;
    /* border:1px solid #ccc; */
}
.select-radio[type='radio']{
    display:none;
}
input:checked+span{
    color:#fff;
    background-color:#2196f3;
    /* -webkit-transform: scale( 1.1 );
    -ms-transform: scale( 1.1 );
    -o-transform: scale( 1.1 );
    transform: scale( 1.1 ); */
}
table tr{
    height:30px;
}
</style>



// WEBPACK FOOTER //
// Status.vue?55317123